import type { Store } from './Store';

export enum StoresInventoryStatus {
    DISABLED = 'DISABLED',
    NOT_LOADED = 'NOT_LOADED',
    PRODUCT_AVAILABLE = 'PRODUCT_AVAILABLE',
    PRODUCT_AVAILABLE_IN_ANOTHER_QUANTITY = 'PRODUCT_AVAILABLE_IN_ANOTHER_QUANTITY',
    PRODUCT_NOT_AVAILABLE = 'PRODUCT_NOT_AVAILABLE',
    PRODUCT_NOT_ELIGIBLE = 'PRODUCT_NOT_ELIGIBLE',
    PRODUCT_NOT_FOUND = 'PRODUCT_NOT_FOUND',
    PRODUCT_ONLY_AVAILABLE_IN_ANOTHER_VARIANT = 'PRODUCT_ONLY_AVAILABLE_IN_ANOTHER_VARIANT',
    STORE_NOT_ELIGIBLE = 'STORE_NOT_ELIGIBLE',
    STORE_NOT_FOUND = 'STORE_NOT_FOUND',
}

export interface StoreInventory {
    status: StoresInventoryStatus;
    productId: string;
    quantityAvailable?: number;
    store?: Store;
}
